import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const InventoryViewType = createEnum([
  "purchase-orders",
  "shipments",
  "transfers",
  "inventory-levels",
  "catalog-products",
]);
export type InventoryViewType = z.infer<typeof InventoryViewType>;
